import gql from 'graphql-tag';

const PROCESS_SIMULATION_MUTATION = gql`
  mutation(
      $simulationId: Int!,
      $calculationType: Int!,
      ) {  
      processSimulation(
      simulationId: $simulationId,
      calculationType: $calculationType,
    ){
      simulationId
    }
  }
`;

export default PROCESS_SIMULATION_MUTATION;
